(function ($, pw) {

    "use strict";

    pw.doc('FlashMessenger', '0.1.171216');

    $(document)
        .on('pw.message', '.flash-messenger', function () {
            console.warn('Deprecated trigger: pw.message use flash:message.pw', 'Rewrite Event to flash:message.pw');
            $(this).trigger('flash:message.pw');
        })
        .on('flash:message.pw', '.flash-messenger', function () {

        var c = $(this), // container s
            i = c.find('.not-init');

        i.each(function () {
            var ui = $(this).removeClass('not-init').hide().slideDown(),
                delay = setTimeout(function () {
                    ui.slideUp(500).fadeOut(500,function (e) {
                        ui.remove();
                    });
                    console.log('Close flash message')
                }, 2800)
            ;
            ui.data('delay', delay);
        });

    });

    $('#flashMessenger').trigger('flash:message');

})(jQuery, window.pw);